import React from 'react';
import { withHandlers } from 'recompose';

const DateInput = ({ inputClass, handleClick, value }) => (
  <button className={inputClass} onClick={handleClick}>
    <span className="fontawesome-calendar" />
    <span className="caption">{value}</span>
  </button>
);

export default withHandlers({
  handleClick: ({ onClick }) => event => onClick && onClick(event),
})(DateInput);



// WEBPACK FOOTER //
// ./src/components/Calendar/DateInput.jsx